import { FC, useMemo } from 'react';

import { CartLineItem } from '@/types';
import { useActiveProductBadges } from 'hooks/useActiveProductBadges';
import { ProductBadge } from '@/components';

const CartItemBadges: FC<ICartItemBadges> = ({
  product,
  badgeClass,
  containerClass,
}) => {
  const { badges, shouldRender } = useActiveProductBadges({
    product,
    weightVariant: product?.weightVariant,
    badgeClass,
  });

  const renderedBadges = useMemo(
    () =>
      badges.map(({ props }, index) => <ProductBadge {...props} key={index} />),
    [badges],
  );

  if (!shouldRender || badges.length === 0) return null;

  return <div className={containerClass}>{renderedBadges}</div>;
};

interface ICartItemBadges {
  product: CartLineItem;
  badgeClass?: string;
  containerClass?: string;
}

export { CartItemBadges };
